module.exports = __webpack_public_path__ + "static/img/knowledge-domain.4676daf1.png";